import { getCountryLabel, isValidCountryCode, normalizeCountryCodeInput } from '@/lib/country-codes'

const JUNK_LOCATION_PARTS = new Set(['null', 'none', 'n/a', 'na', 'undefined'])

/** Strip whitespace and reject LLM/JSON placeholder strings (e.g. literal "null"). */
export function sanitizeEntityLocationPart(value?: string | null): string {
  const trimmed = (value ?? '').trim()
  if (!trimmed || JUNK_LOCATION_PARTS.has(trimmed.toLowerCase())) return ''
  return trimmed
}

/** City + country line for profiles and organisations (ISO code when set, else legacy free text). */
export function formatEntityLocation(
  city?: string | null,
  country?: string | null,
  locale = 'en-AU',
): string {
  const cityTrim = sanitizeEntityLocationPart(city)
  const countryRaw = sanitizeEntityLocationPart(country)
  if (!cityTrim && !countryRaw) return ''

  const looksLikeIsoCode = /^[a-zA-Z]{2}$/.test(countryRaw)
  const code = looksLikeIsoCode ? normalizeCountryCodeInput(countryRaw) : ''
  if (code && isValidCountryCode(code, locale)) {
    if (cityTrim) return `${cityTrim}, ${code}`
    return getCountryLabel(code, locale)
  }

  return [cityTrim, countryRaw].filter(Boolean).join(', ')
}
